module.exports = __webpack_public_path__ + "img/photo-experiences-txoco.1a971e5c.png";